export default {
    lang: {
        name: 'Collection'
    }
}